import * as yup from 'yup';
import { getDay100YearsBefore } from '@/utils/dates/dates';
import { isCarChange } from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';

export const vorfahrzeugContractSchema = yup.object({
  verbleib: yup
    .string()
    .default('')
    .when({
      is: () => isCarChange.value,
      then: yup.string().required(),
    }),
  datum: yup
    .date()
    .nullable()
    .min(getDay100YearsBefore())
    .default(null)
    .when('verbleib', {
      is: (val: string) =>
        isCarChange.value &&
        getSimpleChoiceMeta(
          SIMPLE_CHOICE.VORFAHRZEUG_VERBLEIB,
          SIMPLE_CHOICE_META.VORFAHRZEUG_IST_ABGEMELDET_VERKAUFT,
        ).includes(val),
      then: yup.date().required(),
    }),
  kennzeichen: yup
    .string()
    .default('')
    .when({
      is: () => isCarChange.value,
      then: yup.string().required(),
    }),
  wkz: yup
    .string()
    .default('')
    .when({
      is: () => isCarChange.value,
      then: yup.string().required(),
    }),
});
